import { render, staticRenderFns } from "./TeamMemberForm.vue?vue&type=template&id=9cc85d60"
import script from "./TeamMemberForm.vue?vue&type=script&lang=js"
export * from "./TeamMemberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports